export default "__VITE_ASSET__haCy1Ptl__"